import {appUrl} from '@frontend/AppUrl'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'

// Создание ссылки на страницу заказчика услуг.
export function makeServiceRequesterUrl(userId: number): string {
    return NavigationService.makeUrl(
        appUrl().serviceRequester.details,
        {id: userId}
    )
}
